module.exports = __webpack_public_path__ + "img/JM.6823111d.png";